var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss-live-page"},[_c('banner-video',{attrs:{"vm":_vm.contentBanner}}),_c('teach-method'),_c('service-support'),_c('subject-intro'),_c('quality')],1)}
var staticRenderFns = []

export { render, staticRenderFns }